module.exports = __webpack_public_path__ + "5223a3e1d67dfb84bd4120ff5994ba1b.svg";